const XRPL_META_MPT_URL = 'https://s1.xrplmeta.org/v2/tokens/mpt?limit=500&offset=0&sort_by=holders';

function safeUrl(value) {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}

export async function discoverMetadataMpts(signal) {
  const response = await fetch(XRPL_META_MPT_URL, { signal });
  if (!response.ok) throw new Error(`XRPLMeta returned HTTP ${response.status}.`);
  const payload = await response.json();
  const tokens = Array.isArray(payload.tokens) ? payload.tokens : [];

  const programs = [];
  const supplies = [];
  for (const token of tokens) {
    const metadata = token?.meta?.token || {};
    const assetClass = String(metadata.asset_class || '').toLowerCase();
    if (!['rwa', 'stablecoin'].includes(assetClass)) continue;
    if (!token.issuer || !token.mpt_issuance_id) continue;

    const issuanceId = String(token.mpt_issuance_id).toUpperCase();
    const ticker = metadata.ticker || metadata.name || 'MPT';
    const id = `metadata-mpt-${issuanceId.toLowerCase()}`;
    const firstWebsite = (metadata.uris || []).map((item) => safeUrl(item.uri)).find(Boolean);
    const program = {
      id,
      name: metadata.name || `${ticker} MPT`,
      ticker,
      category: assetClass === 'stablecoin' ? 'stablecoin' : 'rwa',
      availability: 'metadata',
      verification: 'metadata',
      hq: null,
      summary: metadata.desc || `Self-described ${assetClass} metadata published for an XRPL multi-purpose token.`,
      evidence: 'Discovered through XRPLMeta. Classification and backing are self-published and have not been independently verified by AssetGlobe.',
      instruments: [{
        kind: 'mpt',
        issuer: token.issuer,
        issuanceId,
        ticker,
        unit: 'raw units',
      }],
      sources: [
        { label: 'XRPLMeta record', url: `https://xrplmeta.org/token/${issuanceId}` },
        ...(firstWebsite ? [{ label: 'Publisher website', url: firstWebsite }] : []),
      ],
      discovery: {
        subclass: metadata.asset_subclass || 'unspecified',
        issuerName: metadata.issuer_name || token?.meta?.issuer?.name || null,
        holders: Number(token?.metrics?.holders || 0),
      },
    };
    programs.push(program);
    supplies.push({
      key: `${id}:${issuanceId}`,
      programId: id,
      programName: program.name,
      category: program.category,
      availability: 'metadata',
      verification: 'metadata',
      kind: 'mpt',
      issuer: token.issuer,
      issuanceId,
      currency: issuanceId,
      ticker,
      unit: 'raw units',
      gross: Number(token?.metrics?.supply || 0),
      excluded: 0,
      circulating: Number(token?.metrics?.supply || 0),
      holders: Number(token?.metrics?.holders || 0),
      ledgerIndex: null,
      source: 'xrplmeta',
    });
  }

  return {
    programs,
    supplies,
    totalMpts: Number(payload.count || tokens.length),
    discoveredAt: new Date().toISOString(),
  };
}
